(function (){
    'use strict';
    angular.module('app').controller('AffiliateEditAccountsController',AffiliateEditAccountsController);
    AffiliateEditAccountsController.$inject=[
        'AffiliateService',
        '$window',
        '$routeParams',
        'toastr',
        '$scope',
        '$rootScope'
    ];

    function AffiliateEditAccountsController(AffiliateService,$window,$routeParams,toastr,$scope,$rootScope){
        const vm = this;
        vm.role = $rootScope.GlobalProfile.permissionGroup.roles.find(per=> per.code == 'ROLE_COMPANY_ADMIN' || per.code == 'ROLE_ADMIN' );
        vm.id = $routeParams.id;
        vm.companDisabled = true;
        
        vm.goBack = goback;
        vm.onSubmit = function(form){
            if(form.$invalid){
                for(let field of $scope.form.$error.required){
                    if(field.$name){
                        $scope.form[field.$name].required = true;
                        $scope.form[field.$name].$touched = true;
                    }
                }
                return;
            }
            let data = angular.copy(vm.marketingCompany);
            data.location = vm.location
            save(data);
        }

        init()
        function init(){
            vm.bankDetails = true;
            getUserMarketingDetails();
        }

        function goback(){
            $window.history.back();
        }

        function getUserMarketingDetails(){
            AffiliateService.userMarketingDetails(
                res=>{
                    vm.marketingCompany = res;
                    vm.marketingCompany.name =res.companyMarketing.name;
                    vm.location = res.location;
                },
                err=>{
                    console.log(err);
                },vm.id
            )
        }

        function save(data){
            vm.loading =true;
            const payload  = AffiliateService.cleanPayload(data);
            AffiliateService.updateUserMarketing(data.id,
                res=>{
                    toastr.success('Successfully update!');
                    vm.loading =false;
                    getUserMarketingDetails();
                },
                err=>{
                    vm.loading =false;
                    toastr.error(err.message)
                },payload)
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/accounts/AffiliateEditAccountsController.js